var symphony = symphony || {};

;
(function () {

	symphony.scrollToNextSection = function () {

		$('.heroArrow.js-scrollNextSection').on('click', function (e) {
			e.preventDefault();
			performScroll(this);
		});
		$('.heroArrow.js-scrollNextSection').on('keypress', function (e) {
			if (e.keyCode == 13) {
				e.preventDefault();
				performScroll(this);
			}
		});

		function performScroll(elm) {
			var scrollDistance = $(elm).parents('.heroContainer').eq(0).offset().top + $(elm).parents('.heroContainer').eq(0).outerHeight();
			if (!document.body.classList.contains('kroc-theme')) {
				if ($('body').hasClass('localSite')) {
					// header
					scrollDistance -= 66;
					if ($('body').hasClass('hasGivingToolbar')) {
						// giving toolbar
						scrollDistance -= 48;
					}
				} else {
					// thq header
					scrollDistance -= 62;
				}
			}

			$("html, body").animate({
				scrollTop: scrollDistance
			}, 500, function () {
				if (!$('body').hasClass('kroc-theme')) {
					$('body').addClass('header-isSticky');
					$('body').addClass('givingToolbar-isSticky');
				}
			});
		}

		$('.js-scrollNextSection:not(.heroArrow)').on('click', function (e) {
			e.preventDefault();

			var $parent = $(e.target).parent();
			var scrollDistance = $parent.offset().top + $parent.outerHeight();
			if ($('body').hasClass('localSite')) {
				// header
				scrollDistance -= 66;
				if ($('body').hasClass('hasGivingToolbar')) {
					// giving toolbar
					scrollDistance -= 48;
				}
			} else {
				// thq header
				scrollDistance -= 62;
			}

			$("html, body").animate({
				scrollTop: scrollDistance
			}, 500);
		});

	};


})();
